import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId, telLink, COMPANY } from "../lib/company";
import { LANGS, useLang } from "../lib/i18n";

const IDS = ["auto", "servizi", "showroom", "contatti"];

const LangSwitch = ({ prefix }) => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex rounded-full border border-[var(--line)] bg-white p-0.5" data-testid={`${prefix}-lang-switch`}>
      {Object.keys(LANGS).map((l) => (
        <button key={l} onClick={() => setLang(l)} data-testid={`${prefix}-lang-${l}`} aria-pressed={lang === l}
          className={`rounded-full px-2.5 h-8 font-mono text-[11px] uppercase font-medium transition-colors ${lang === l ? "bg-[var(--ink)] text-white" : "text-[var(--ink-2)] hover:text-[var(--red)]"}`}>{l}</button>
      ))}
    </div>
  );
};

export const Navbar = () => {
  const { t } = useLang();
  const LINKS = IDS.map((id) => [id, t.nav[id]]);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const nav = useNavigate();
  const go = (id) => {
    setOpen(false);
    if (pathname !== "/") { nav("/"); setTimeout(() => scrollToId(id), 400); }
    else scrollToId(id);
  };
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[var(--bone)]/85 backdrop-blur-md border-b border-[var(--line)]/80" data-testid="navbar">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link"><Logo /></Link>
        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`}
              className="text-sm font-medium text-[var(--ink-2)] hover:text-[var(--red)] transition-colors">
              {label}
            </button>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <LangSwitch prefix="nav" />
          <a href={telLink} data-testid="nav-call-btn"
            className="inline-flex items-center gap-2 rounded-full bg-[var(--ink)] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[var(--red)] transition-colors">
            <Phone className="w-4 h-4" /> {COMPANY.phoneDisplay}
          </a>
        </div>
        <div className="md:hidden flex items-center gap-2">
          <LangSwitch prefix="nav-mobile" />
          <button className="p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-[var(--line)] bg-[var(--bone)] px-5 py-6 space-y-4" data-testid="nav-mobile-menu">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-mobile-link-${id}`}
              className="block font-display text-3xl font-semibold">{label}</button>
          ))}
          <a href={telLink} className="inline-flex items-center gap-2 rounded-full bg-[var(--ink)] text-white px-5 py-3 text-sm font-semibold" data-testid="nav-mobile-call-btn">
            <Phone className="w-4 h-4" /> {COMPANY.phoneDisplay}
          </a>
        </div>
      )}
    </header>
  );
};
